import clsx from 'clsx';

import SvgCheckmark from '@icons/checkmark.svg?react';

interface Props {
  label: string;
  className?: string;
}

export const Checkmark = ({ label, className }: Props) => {
  return (
    <>
      <div
        className={clsx(
          'w-4 h-4 !ml-0 rounded-sm bg-white text-white border border-solid border-content-gr3 peer-checked:border-content-brand peer-checked:text-content-brand flex items-center justify-center',
          className,
        )}
      >
        <SvgCheckmark />
      </div>
      <span className="text-sm text-content-primary !ml-0">{label}</span>
    </>
  );
};
